// Generated types for PartPerformsTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { NeoNodeReadAPI } from '../../shared/types/neonode';
import { TaskReadAPI, TaskWriteAPI } from '../../tasks/types/task';
import { NeoNodeReadAPISchema } from '../../shared/types/neonode';
import { TaskReadAPISchemaObject, TaskWriteAPISchemaObject } from '../../tasks/types/task';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface PartPerformsTaskReadAPI extends TaskReadAPI {
}

export interface PartPerformsTaskWriteAPI extends TaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const PartPerformsTaskReadAPISchema: z.ZodType<PartPerformsTaskReadAPI> = TaskReadAPISchemaObject.extend({}).passthrough();

export const PartPerformsTaskWriteAPISchema: z.ZodType<PartPerformsTaskWriteAPI> = TaskWriteAPISchemaObject.extend({}).passthrough();
